import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import "../css/Checkin.css";

const MOODS = [
  { label: "Great", emoji: "😄" },
  { label: "Good", emoji: "🙂" },
  { label: "Okay", emoji: "😐" },
  { label: "Tired", emoji: "😴" },
  { label: "Sad", emoji: "😢" },
];

export default function Checkin() {
  const { submitCheckin, loading } = useAuth();

  const [mood, setMood] = useState("");
  const [journal, setJournal] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!mood) {
      setError("Please select a mood before submitting.");
      return;
    }

    const ok = await submitCheckin({ mood, journal });
    if (ok) setSubmitted(true);
    else setError("Failed to submit check-in. Please try again.");
  };

  if (submitted) {
    return (
      <div className="checkin-wrapper">
        <div className="checkin-success">
          <div className="checkin-success-icon">✓</div>
          <h2>Check-in Saved!</h2>
          <p>Thanks for sharing. Keep it up!</p>
          <button
            className="checkin-btn"
            onClick={() => { setSubmitted(false); setMood(""); setJournal(""); }}
          >
            New Check-in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="checkin-wrapper">
      <div className="checkin-card">
        <h2>Weekly Check-in</h2>
        <p className="checkin-subtitle">How are you feeling this week?</p>

        {error && <div className="checkin-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="checkin-mood-row">
            {MOODS.map(({ label, emoji }) => (
              <button
                key={label}
                type="button"
                className={`checkin-mood-btn ${mood === label ? "selected" : ""}`}
                onClick={() => setMood(label)}
              >
                <span className="checkin-emoji">{emoji}</span>
                <span className="checkin-mood-label">{label}</span>
              </button>
            ))}
          </div>

          <div className="checkin-journal">
            <label htmlFor="checkin-journal-input">
              Anything you'd like to share? (optional)
            </label>
            <textarea
              id="checkin-journal-input"
              placeholder="Write about your week, challenges, or wins..."
              value={journal}
              onChange={(e) => setJournal(e.target.value)}
              rows={5}
              maxLength={500}
            />
            <span className="checkin-char-count">{journal.length}/500</span>
          </div>

          <button className="checkin-btn" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Submit Check-in"}
          </button>
        </form>
      </div>
    </div>
  );
}
